import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { EmpresaDtoUpdate, EmpresaList } from '../../../empresas-list/core/_models'
import {
  getContatoOfAgendamentoByEmpresa,
  getEmpresaById,
  getLogo,
  toggleStatusEmpresa,
} from '../../../empresas-list/core/_requests'
import { ClientesModal } from '../../components/modal/ClientesModal'
import { useT } from '_metronic/i18n/Metronici18n'
import { getTiposAtendimentos } from '_metronic/helpers/crud-helper/_request'

type Props = {
  empresa: EmpresaList
}

export const ClientesActionsCell: FC<Props> = ({ empresa }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { t } = useT()
  const { refetch } = useQueryResponse()
  const navigate = useNavigate()
  const nome = empresa.nomeFantasia || empresa.nome || t('entidade.label')

  const openEditModal = () => {
    showModal({
      title: t('entidade.label'),
      content: <ClientesModal />,
      size: ModalSize.ExtraLarge,
      fetchers: {
        logo: () => getLogo(empresa.id),
        empresa: () => getEmpresaById(empresa.id),
        contato: () => getContatoOfAgendamentoByEmpresa(Number(empresa.id)),
        tiposAtendimento: () => getTiposAtendimentos(),
      },
    })
  }

  const setStatus = async (ativa: boolean) => {
    try {
      showAlertLoading()
      const data: EmpresaDtoUpdate = {
        id: Number(empresa.id),
        cnpj: String(empresa.cnpj),
        ativa,
      }
      await toggleStatusEmpresa(Number(empresa.id), data)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi ${ativa ? 'ativada' : 'inativada'}.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  // Inativar pede confirmação explicando a consequência; ativar é reversível e não pede.
  const askInativar = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Inativar entidade?',
      text: `${nome} deixará de aparecer para novos atendimentos e agendamentos. Endereços e histórico continuam guardados, e você pode reativá-la quando quiser.`,
      confirmButtonText: 'Inativar',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await setStatus(false)
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        {
          label: 'Listar endereços',
          onClick: () => navigate(`/apps/enderecos/entidade/${empresa.id}`),
        },
        empresa.ativa
          ? { label: 'Inativar', onClick: askInativar, danger: true, divider: true }
          : { label: 'Ativar', onClick: () => setStatus(true), divider: true },
      ]}
    />
  )
}
